module.exports = __webpack_public_path__ + "img/r-2-actbtn.5b717b81.png";